export const VERIFY_PIN = "VERIFY_PIN";
export const TOO_MANY_ATTEMPTS = 429;
export const ADMIN_ONLY_MESSAGE = "عذرًا ، الحساب متاح للمشرف الفائق فقط";

const ADMIN_TYPES = ["SYSTEM_ADMIN", "CONTENT_MODERATOR"];

export const isAdmin = (type) => ADMIN_TYPES.includes(type);

export function getContact({ countryCode, mobileNumber, emailId }) {
  return mobileNumber === ""
    ? { _contactType: "email", _emailOrMobile: emailId }
    : { _contactType: "mobile", _emailOrMobile: countryCode + mobileNumber };
}

export function saveSession({
  _name,
  _token,
  _refreshToken,
  _schoolId,
  _classIds,
  _userTypeId,
  _teacherId,
}) {
  localStorage.setItem("userName", _name);
  localStorage.setItem("abjadToken", _token);
  localStorage.setItem("refreshToken", _refreshToken);
  localStorage.setItem("schoolId", _schoolId);
  _classIds && localStorage.setItem("classIds", _classIds);
  localStorage.setItem("roleId", _userTypeId);
  localStorage.setItem("teacherId", _teacherId);
}

export function toLockoutMessage(retryAfterSeconds) {
  if (!retryAfterSeconds) return { key: "lockedLater" };
  if (retryAfterSeconds >= 3600) {
    return {
      key: "lockedHours",
      values: { time: Math.ceil(retryAfterSeconds / 3600) },
    };
  }
  return {
    key: "lockedMinutes",
    values: { time: Math.ceil(retryAfterSeconds / 60) },
  };
}
